import { render, staticRenderFns } from "./usersForm.vue?vue&type=template&id=b1a61e2e"
import script from "./usersForm.vue?vue&type=script&lang=js"
export * from "./usersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports